import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=6c9b481f&scoped=true"
import script from "./MessagesTable.vue?vue&type=script&lang=js"
export * from "./MessagesTable.vue?vue&type=script&lang=js"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=6c9b481f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9b481f",
  null
  
)

export default component.exports